module.exports = __webpack_public_path__ + "static/img/1_1_2_2.a2e49dbc.jpg";